import { useEffect, useState, useCallback } from 'react';
import { dynamicManager } from 'pages/FormProcess/DynamicForm/DynamicManager';

export function useCommentPopoverManager(isOpenPopover?: boolean, listType?: string) {
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const [isReady, setReady] = useState(false);
  const [offset, setOffset] = useState(0);
  const [activeKey, setActiveKey] = useState<string>();

  const isFormCommentsList = listType === 'FormComments';

  useEffect(() => {
    setPopoverOpen(!!isOpenPopover);
  }, [isOpenPopover]);

  useEffect(() => {
    if (isFormCommentsList) {
      dynamicManager.setCommentPopover(isPopoverOpen);
      if (isPopoverOpen) {
        setActiveKey('1');
        managePopoverOffset();
        setReady(true);
      } else {
        setReady(false);
      }
    }
  }, [isPopoverOpen]);

  const managePopoverOffset = useCallback(() => {
    requestAnimationFrame(() => {
      const mainDiv = document.querySelector('[itemid^="main-page-content"]') as HTMLElement;
      const formDocument = document.getElementById('printFormDocument') as HTMLElement;
      const popover = document.querySelector('.comment-popover-overlay') as HTMLElement;

      if (!mainDiv || !formDocument || !popover) return;

      const mainDivWidth = mainDiv.offsetWidth;
      const commentIndicatorWidth = popover.offsetWidth;
      const formWidth = formDocument.offsetWidth;

      const availableSpaceLeft = (mainDivWidth - (commentIndicatorWidth + formWidth + 50)) / 2;
      let newOffset = 0;
      if (availableSpaceLeft > 150) {
        popover.style.left = '0px';
      } else if (availableSpaceLeft > 50) {
        popover.style.left = '-180px';
        newOffset = -180;
      } else {
        popover.style.left = `${-200 + availableSpaceLeft}px`;
        newOffset = -200 + availableSpaceLeft;
      }

      setOffset(newOffset);
    });
  }, []);

  return {
    isPopoverOpen,
    setPopoverOpen,
    isReady,
    offset,
    activeKey,
    setActiveKey,
  };
}
